import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription, debounceTime, distinctUntilChanged } from 'rxjs';

export interface FilterValues {
  search: string;
  status: any;
  dateRange: Date[] | null;
}

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrl: './filter.component.scss',
  standalone: false
})
export class FilterComponent implements OnInit, OnDestroy {

  @Input() searchPlaceholder = 'Search...';
  private _statusOptions: any[] = [];
  private selectedStatus: any = '';

  @Input()
  set statusOptions(options: any[]) {
    this._statusOptions = options || [];
    this.syncStatus();
  }

  get statusOptions(): any[] {
    return this._statusOptions;
  }

  @Input()
  set initialStatus(status: any) {
    this.selectedStatus = status ?? '';
    this.syncStatus();
  }

  @Input() searchHint: string = '';
  status: any = '';

  @Output() filterChange = new EventEmitter<FilterValues>();

  searchControl = new FormControl('');
  rangeDates: Date[] | null = null;
  maxDate: Date = new Date();

  private searchSub?: Subscription;

  ngOnInit(): void {
    this.searchSub = this.searchControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(() => this.emitChange());
  }

  ngOnDestroy(): void {
    this.searchSub?.unsubscribe();
  }

  onStatusChange(): void {
    this.emitChange();
  }

  onDateSelect(): void {
    // Range mode fires onSelect on each click; only emit once both ends are picked.
    if (this.rangeDates && this.rangeDates.length === 2 && this.rangeDates[0] && this.rangeDates[1]) {
      this.emitChange();
    }
  }

  resetFilters(): void {
    this.searchControl.setValue('', { emitEvent: false });
    this.status = '';
    this.rangeDates = null;
    this.emitChange();
  }

  private syncStatus(): void {
    const requestedStatus = String(this.selectedStatus).toLowerCase();
    const matchedOption = this.statusOptions.find(
      option => String(option?.value ?? '').toLowerCase() === requestedStatus
    );

    this.status = matchedOption?.value ?? '';
  }

  private emitChange(): void {
    this.filterChange.emit({
      search: this.searchControl.value ?? '',
      status: this.status,
      dateRange: this.rangeDates,
    });
  }
}
